import { Directive } from '@angular/core';
import { TemplateRefDirective } from 'src/app/utils/template-ref-directive';

@Directive({
    selector: '[appListingFooter]',
    standalone: false
})
export class ListingFooterDirective extends TemplateRefDirective {
}
